import { z } from 'zod';

const trendingItemSchema = z.object({
  menu_item_id: z.number(),
  name: z.string(),
  price: z.number(),
  calories: z.number(),
  in_stock: z.boolean(),
  priority: z.number(),
  status: z.object({
    id: z.number(),
    name: z.string(),
  }),
  description: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  categories: z.array(
    z.object({
      category_id: z.number(),
      name: z.string(),
    }),
  ),
  schedules: z.array(
    z.object({
      schedule_id: z.number(),
      name: z.string(),
    }),
  ),
  diet: z.object({
    diet_id: z.number(),
    name: z.string(),
  }),
  image_url: z.string().nullable(),
  addon_item_choices: z.array(z.string()),
});

export type TrendingItem = z.infer<typeof trendingItemSchema>;

export const trendingItemService = z.array(trendingItemSchema);
